import { type RovoInstrumentedError } from '@atlassian/conversation-assistant-instrumentation';

/**
 * This is the copied version from `conversation-assistant-instrumentation/src/common/utils/fetch-error.ts`
 * @todo remove duplicate
 */
export class FetchError extends Error implements RovoInstrumentedError {
	constructor(
		message: string,
		public errorAttributes: {
			statusCode?: number;
			traceId?: string;
			requestId?: string;
			rawErrorMessage?: string;
			errorCode?: string;
		},
	) {
		super(message);
		this.name = 'FetchError';
	}
}
